<template>
  <v-container>
    <div class="text-center">
      <h1 class="d-block">
        Invalid link
      </h1>
      <v-img
        class="mx-auto my-6"
        src="https://res.cloudinary.com/dlw64o4rf/image/upload/v1604329288/web%20images/cc-survey-expired_nlwhov.svg"
        width="400"
      ></v-img>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "SurveyInvalid",
  components: {}
};
</script>
